
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as PauseIconComponent } from "./pause-icon.svg";

export const PauseIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <PauseIconComponent {...props} />;
};
